<template>
        <v-container fluid class="ma-0 pa-0" width="100%">
        <v-row class="blue darken-4" style="height:45px;">
            <v-col cols="3" class="ma-0 pa-0 text-left pl-1 mt-1">
            <div v-if="backVisible == true" >
                
                <v-btn color="primary" fab small dark @click="navigateTo()" icon>
                <v-icon class="white--text">mdi-arrow-left-bold</v-icon>
                </v-btn>
            </div>
            <!-- <div v-if="$router.currentRoute.name == 'Home' && appUpdateNeeded == true" >
                <v-btn color="primary" fab small dark @click="reload()" icon>
                <v-icon class="white--text">mdi-refresh</v-icon>
                </v-btn>
            </div> -->
            </v-col>
            <v-col class="ma-0 pa-0 text-center mt-2">
            <div v-if="($vars.AppEnvironment != 'dev' && $vars.AppEnvironment !='local')">
                <span class="text-h6 white--text">{{appTitle}}</span>
            </div>
            <div v-else >
                <span class="text-h6 white--text">{{'** DEV-DEV-DEV **'}}</span>
            </div>
            </v-col>
            <v-col cols="3"  class="ma-0 pa-0 mt-1 text-right">
                <v-btn class="pr-1" v-if="homeVisible == true" color="primary" fab small dark @click="goHome()" icon>
                <v-icon class="white--text">mdi-home</v-icon>
                </v-btn>
                <v-btn class="pr-1" v-if="aboutVisible == true" color="primary" fab small dark @click="aboutModalVisible = true" icon>
                <v-icon class="white--text">mdi-information-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>
            <!-- Begin - About Modal -->
            <v-dialog
                v-model="aboutModalVisible"
                persistent
                width="300"
                dark
            >
                <v-card
                    color="blue darken-4"
                >
                    <v-layout justify-center>
                    <v-card-title class="text-center">Pacific Region<br />Mobile Assistant</v-card-title>
                    </v-layout>
                    <v-card-text>
                    <v-layout justify-center>
                        Version: {{this.$vars.AppVersionString}}<br />
                    </v-layout>
                    </v-card-text>
                    <v-layout justify-center>
                    <v-card-actions>
                        <v-btn color="white" class="blue--text text--darken-4" @click="aboutModalVisible = false">Close</v-btn>
                    </v-card-actions>
                    </v-layout>
                </v-card>
            </v-dialog>
            <!-- End - About Modal -->

        </v-container>
    
</template>

<script>
    export default {
    name: "top-menu",
        data() {
        return {
            aboutModalVisible: false,
            appTitle: 'PCR Mobile App',
        }
    },
    props: {
        backVisible: {type: Boolean, required: true},
        homeVisible: {type: Boolean, required: true},
        aboutVisible: {type: Boolean, required: true}
    },
    methods:{
        navigateTo() {
            //this.$router.push(this.previousRoute)
            if (this.$routerHistory.hasPrevious())
            {
                this.$router.push(this.$routerHistory.previous().path)
            }
        },
        goBack() {
        //var newIndex = (this.globalIndex) + 1;
        //this.setGlobalIndex(newIndex);
        this.$router.back();
        },
        goHome() {
        //var newIndex = 0;
        //this.setGlobalIndex(newIndex);
        this.$router.push({name:'Home'});
        },
        reload() {
        this.$router.go();
        this.setAppUpdateNeeded(false);
        //console.log("test");
        },
    }
    };
</script>
